import useLogin from '../providers/use_login';
import API from '../providers/api';
import { useState } from 'react';

export default () => {
  const { user, token } = useLogin()
  const [isBusy, setIsBusy] = useState(false)

  const sendPropuesta = async (body, onSuccess, onFail) => {
    setIsBusy(true)
    if (!user) return
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
    const res = await API.post('articulos/post', body, config)
    setIsBusy(false)

    if (res?.status !== 204) {
      if (onFail) onFail()
      return
    }

    if(onSuccess) onSuccess()
  }

  return { sendPropuesta, isBusy };
}